import { NodeViewWrapper, NodeViewContent } from '@tiptap/react';

import { TableCellMenu } from '../table-cell-menu';

export default function TableCellRenderer() {
  return (
    <NodeViewWrapper>
      <NodeViewContent />
      <TableCellMenu />
    </NodeViewWrapper>
  );
}
